<template>
  <layout 
    :showuserinfo="false" 
    title="Cukai Petak" 
    :crumbs="crumbs"
  >
      <z-page title="Sistem Hasil Bersepadu Kedah (iHasil)">
        
        <w-dialog
        v-model="dialog.show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-light1--bg white">
        <template #title>
          <w-icon class="mr2">fal fa-cog</w-icon>
          Sunting
        </template>

        <w-form 
          ref="dform" 
          v-model="dialog.valid"
          @validate="submit"
          @success="success"
        >
        
        <z-input label="Name" name="name" :validators="[validators.required]" />

        <z-input class="mt3" label="Email" name="email" :validators="[validators.required]" />

        <z-input class="mt3" label="Mobile" name="mobile" :validators="[validators.required]" />

        </w-form>

        
        <template #actions>
          <div class="spacer" />
          <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
          <w-button 
          class="ml1" 
          :loading="dialog.loading"
          @click="$refs.dform.validate()"
          >
            Simpan
          </w-button>
        </template>

        
      </w-dialog>

        <z-table ref="tbluser" title="Senarai Cukai Petak" :headers="table.headers" :items="table.items" :meta="table.meta" class="white--bg">
            <template #button>
              <w-button 
              dark
              class="indigo-dark2--bg ml1 fs-2" 
              @click="newrecord()"
              >
                <w-icon class="mr1" xs>fal fa-plus</w-icon> Cipta
              </w-button>
            </template>
            
            <template #item-cell.action="{ item, label, header, index }">
              <w-flex class="flex justify-center">
                <inertia-link :href="item.show">
                <w-tooltip top>
                    <template #activator="{ on }">
                      <w-icon v-on="on" >
                        fal fa-file
                      </w-icon>
                    </template>
                    Papar
                  </w-tooltip>
                </inertia-link>
              </w-flex>
            </template>
        </z-table>
    </z-page>
  </layout>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: 'cukai-tanah',
        reload: true,
        crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Cukai Petak', route: '/cukai-petak/dashboard' },
        { label: 'Senarai', route: '/cukai-petak/senarai' },
          ],
          form: {
            },
        }
  },
  methods: {
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>